
import { useStore } from 'vuex'
import { computed, reactive } from 'vue';

export default {
	emits: ['hide','submitGiftType'],
	name: 'DialogApplyGift',
	props: ["gift"],
	setup(props, { emit }) {
		const store = useStore()
		const local = computed(() => store.state.translation.locale)
		

		

		const data = reactive({
			errorMessage: ''
		})

		



		const hide_ = () => {
			emit('hide')
		}

        const submitGiftType_ = (type) => {
            emit('submitGiftType',type,props.gift.id)
        }

		return {
			local,
			props,
			data,
			hide_,
            submitGiftType_
		}
	}
}
